<div class="chart-zoom-controls"
    #controls
    *ngIf="(chart$ | async)?.enabled"
    [style.top.px]="top"
    style="right: auto;"
    [style.visibility]="visible"
    [style.left]="chartLeft$ | async">
    <!-- We use *ngIf here because [hidden] conflicts with the display value in visible-lg-block css -->
    <div class="chart-zoom-controls-item text-prewrap chart-zoom-controls-info visible-lg-block"
        *ngIf="!zoomOn; else zoomBtns"
        [textContent]="'Select area\n to zoom'"
        ycnTooltip
        [hidden]="hideZoomInstructions"
        [style.visibility]="hideZoomInstructions ? 'hidden' : 'visible'"
        [tooltipTitle]="'Click and drag to select<br>area and zoom'"
        tooltipPlacement="bottom-end"
        [tooltipHtml]="true">
    </div>
    <ng-template #zoomBtns>
        <div class="chart-zoom-controls-item">
            <div class="btn btn-secondary"
                ycnTooltip
                tooltipTitle="Reset"
                tooltipPlacement="bottom"
                (click)="resetZoomHandler()">
                    <svg ycnIcon [name]="'icon-reset-zoom'"></svg>
            </div>
        </div>
        <div class="chart-zoom-controls-item visible-lg-block"
            [ngStyle]="{'display': zoomOn ? 'initial' : 'none'}">
            <div class="btn"
                #panningButton
                [ngClass]="enablePanning ? 'btn-primary' : 'btn-secondary'"
                [tabIndex]="-1"
                ycnTooltip
                tooltipTitle="Move (SHIFT + Click)"
                tooltipPlacement="bottom"
                (click)="panningHandler($event)">
                    <svg ycnIcon [name]="'icon-move'"></svg>
            </div>
        </div>
    </ng-template>
    <ng-content></ng-content>
</div>
